import type { InventoryUnit } from "../types";
import { InventoryToteIcon } from "./TotePixelIcon";

export function isHdxTote(unit: InventoryUnit) {
  return unit.inventory_type === "TOTE" && unit.container_type === "HDX Tough Tote";
}

export function InventoryVisual({ unit, compact = false }: { unit: InventoryUnit; compact?: boolean }) {
  if (isHdxTote(unit)) {
    return (
      <span className={`inventory-visual tote-visual${compact ? " compact" : ""}`}>
        <InventoryToteIcon unit={unit} />
      </span>
    );
  }

  const photo = unit.photos[0];
  return (
    <span className={`inventory-visual photo-visual${compact ? " compact" : ""}`}>
      {photo ? (
        <img src={photo.thumbnail_url || photo.url} alt={`${unit.name} thumbnail`} />
      ) : (
        <span aria-label={`${unit.name} has no photo`}>{unit.inventory_type.slice(0, 2)}</span>
      )}
    </span>
  );
}
